import type { I18n } from 'vue-i18n'

const translationModules: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  it: () => import('./it/index'),
  en: () => import('./en/index')
}

export async function loadLocaleMessages(i18n: I18n, locale: string) {
  const loader = translationModules[locale]
  if (!loader) {
    console.warn(`Locale ${locale} not found, falling back to 'it'`)
    return
  }

  const messages = await loader()
  i18n.global.setLocaleMessage(locale, messages.default)
  ;(i18n.global.locale as any).value = locale
}

export function isLocaleLoaded(i18n: I18n, locale: string): boolean {
  return i18n.global.availableLocales.includes(locale as any)
}
